<div class="period-header-content">
  <div
    class="period-header-text"
    matTooltip="{{
      locale.translate('closingDate', {
        closingDate: getSaleOrderPeriodClosingDate(rowName),
      }) | translate
    }}"
    matTooltipPosition="below"
  >
    {{ rowName }}
  </div>
  <button (click)="movePeriodData()" mat-icon-button class="mat-icon-button" data-test="move-product-line">
    <mat-icon>content_copy</mat-icon>
  </button>
</div>
